import * as React from "react";
import { Typography, Grid, useMediaQuery } from "@mui/material";
import { FB_IMAGE_WIX, DEFAULT_PROFILE_IMAGE } from "../constants";

export const CalendarBranding = ({
  fullName,
  imageUrl,
  timezone,
  calDescription,
  showTimezoneChoose,
  userSelectTimezone,
}) => {
  const isMobile = useMediaQuery("(max-width:900px)");

  return (
    <Grid
      container
      className="calendar-branding-container"
      spacing={isMobile ? 0 : 2}
    >
      <Grid item xs={12} className="calendar-branding-image">
        <img
          height={69}
          src={imageUrl || DEFAULT_PROFILE_IMAGE}
          alt="brand img"
        />
      </Grid>
      <Grid item xs={12} className="calendar-branding-name">
        <Typography>{fullName}'s Calendar</Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          className="mobile-timezone"
        >
          All times in {timezone}
        </Typography>
      </Grid>
      {calDescription && (
        <Grid item xs={12} className="calendar-branding-description">
          {calDescription}
        </Grid>
      )}
    </Grid>
  );
};
